import React, { useState, useEffect } from 'react';
import DisplayCards from './displayCards';
import DisplaySmallCards from './displaySmallCards';
import useIsDeviceMobile from "../hooks/useIsDeviceMobile";

const DealerHand = ({ 
  remainingCards, 
  setRemainingCards,
  stand,
  setStand, 
  dealerScore, 
  setDealerScore, 
  dealerPossibleBlackJack,
  setDealerPossibleBlackJack,
  setDealerBlackJack, 
  playerBlackJack,
  blackJackSplit1,
  blackJackSplit2
}) => {
  const [dealerCards, setDealerCards] = useState([]);
  const [mounted, setMounted] = useState(false);
  const isMobile = useIsDeviceMobile();

  // Cargar cartas del dealer desde localStorage o repartir una
  useEffect(() => {
    const storedDealerCards = localStorage.getItem("dealerCards");

    if (storedDealerCards) {
      const parsedCards = JSON.parse(storedDealerCards);
      setDealerCards(parsedCards);
      setMounted(true);
    } else if (remainingCards.length > 0 && dealerCards.length === 0 && !mounted) {
      setMounted(true);
      dealCard();
    }
  }, [remainingCards]);

  // Guardar cartas del dealer en localStorage cuando cambian
  useEffect(() => {
    if (dealerCards.length > 0) {
      localStorage.setItem("dealerCards", JSON.stringify(dealerCards));
    }
  }, [dealerCards]);

  // Detectar posible blackjack del crupier
  useEffect(() => {
    if (dealerCards.length > 0) {
      const value = getFirstCardValue(dealerCards[0]);      
      if (value === 10 || value === 11) {
        setDealerPossibleBlackJack(true);
      }
    }
  }, [dealerCards]);

  const dealCard = async () => {
    if (remainingCards.length > 0) {
      const drawnCard = remainingCards[0];
      setDealerCards(prevCards => [...prevCards, drawnCard]);
      setRemainingCards(prev => prev.slice(1));
    }
  };

  const getFirstCardValue = (card) => {
    const cardValue = card.slice(0, -1);
    if (isNaN(cardValue)) {
      return cardValue === 'A' ? 11 : 10;
    }
    return parseInt(cardValue);
  };

  useEffect(() => {
    if (stand) {
      dealerPlay();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stand]);

  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const dealerPlay = async () => {
    let aceCount = 0;
    let tempDealerCards = [...dealerCards];
    let tempRemainingCards = [...remainingCards];
    let score = calculateDealerScore(tempDealerCards);
  
    tempDealerCards.forEach(card => {
      if (card[0] === 'A') aceCount++;
    });
  
    while (score < 17 && tempRemainingCards.length > 0) {
      const nextCard = tempRemainingCards.shift(); // Sacar carta de la baraja
      tempDealerCards.push(nextCard);
      setDealerCards([...tempDealerCards]); // Actualiza el estado
      await delay(800);
  
      let value = nextCard.slice(0, -1);
      if (isNaN(value)) {
        if (value === 'A') {
          aceCount++;
          score += 11;
        } else {
          score += 10;
        }
      } else {
        score += parseInt(value);
      }
  
      while (score > 21 && aceCount > 0) {
        score -= 10;
        aceCount--;
      }
    }
  
    setDealerScore(score);
    setRemainingCards(tempRemainingCards); // Actualizar la baraja al final
  
    if (score === 21 && tempDealerCards.length === 2) {
      setDealerBlackJack(true);
    }
  };
  

  const calculateDealerScore = (cards) => {
    let score = 0;
    let aceCount = 0;

    cards.forEach(card => {
      let value = card.slice(0, -1);
      if (isNaN(value)) {
        if (value === 'A') {
          aceCount++;
          value = 11;
        } else {
          value = 10;
        }
      } else {
        value = parseInt(value);
      }
      score += value;
    });

    while (score > 21 && aceCount > 0) {
      score -= 10;
      aceCount--;
    }

    setDealerScore(score);
    return score;
  };

  return (
    <div>
      {!isMobile ? (
        <div>
          {dealerCards.length > 0 && (
            <div className="justify-content-center d-flex">
              <h2>Mano del crupier</h2>
            </div>
          )}
          <div className="justify-content-center d-flex">
            {dealerCards.map((card, index) => (
              <div key={index} className="card-wrapper p-2">
                <DisplayCards card={card} />
              </div>
            ))}
          </div>
          <div className="justify-content-center d-flex ">
            {dealerCards.length > 0 && (
              <button
                className="btn btn-dark m-1"
                onClick={() => setStand(true)}
                disabled={stand || (playerBlackJack && !dealerPossibleBlackJack)}
              >
                Me planto
              </button>
            )}
          </div>
        </div>
      ) : (
        <div>
          {dealerCards.length > 0 && (
            <div className="justify-content-center d-flex">
              <h2>Mano del crupier</h2>
            </div>
          )}
          <div className="justify-content-center d-flex">
            {dealerCards.map((card, index) => (
              <div key={index} className="card-wrapper p-1">
                <DisplaySmallCards card={card} />
              </div>
            ))}
          </div>
          <div className="justify-content-center d-flex ">
            {dealerCards.length > 0 && (
              <button
                className="btn btn-dark m-1"
                onClick={() => setStand(true)}
                disabled={stand || (playerBlackJack && !dealerPossibleBlackJack)}
              >
                Me planto
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DealerHand;
